<!-- Footer Section Begin -->
<footer class="footer1 spad">
  <div class="container">
    <!-- <div class="row">
    <div class="col-lg-3 col-md-6 col-sm-6">
      <div class="footer__about">
        <div class="footer__about__logo">
          <a href="./index.html"><img src="assets/img/logo.png" alt=""></a>
        </div>
        <ul>
          <li>Address: 60-49 Road 11378 New York</li>
          <li>Phone: +65 11.188.888</li>
          <li>Email: hello@colorlib.com</li>
        </ul>
      </div>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-1">
      <div class="footer__widget">
        <h6>Useful Links</h6>
        <ul>
          <li><a href="#">About Us</a></li>
          <li><a href="#">About Our Shop</a></li>
          <li><a href="#">Secure Shopping</a></li>
          <li><a href="#">Delivery infomation</a></li>
          <li><a href="#">Privacy Policy</a></li>
          <li><a href="#">Our Sitemap</a></li>
        </ul>
        <ul>
          <li><a href="#">Who We Are</a></li>
          <li><a href="#">Our Services</a></li>
          <li><a href="#">Projects</a></li>
          <li><a href="#">Contact</a></li>
          <li><a href="#">Innovation</a></li>
          <li><a href="#">Testimonials</a></li>
        </ul>
      </div>
    </div>
    <div class="col-lg-4 col-md-12">
      <div class="footer__widget">
        <h6>Join Our Newsletter Now</h6>
        <p>Get E-mail updates about our latest shop and special offers.</p>
        <form action="#">
          <input type="text" placeholder="Enter your mail">
          <button type="submit" class="site-btn">Subscribe</button>
        </form>
        <div class="footer__widget__social">
          <a href="#"><i class="fa fa-facebook"></i></a>
          <a href="#"><i class="fa fa-instagram"></i></a>
          <a href="#"><i class="fa fa-twitter"></i></a>
          <a href="#"><i class="fa fa-pinterest"></i></a>
        </div>
      </div>
    </div>
  </div>-->
    @if (VER_LOGO_GMSHOP) {
    <div class="row">
      @if (VER_LOGO_GMSHOP) {
      <div class="col-lg-2">
        <a routerLink="home"><img src="assets/img/LOGOTIPOS_GEMMA_6_RESIZED.png" alt="logo" height="30"></a>
      </div>
      }
      @if (VER_LOGO_GMSHOP) {
      <div class="col-lg-10">
        <div class="footer__copyright">
          <div class="footer__copyright__text">
            <p>
              Copyright &copy;
              <script>document.write(new Date().getFullYear());</script> <a href="http://www.asg-si.com" target="_blank"
                i18n>ASG Aplicaciones y sistemas de gestión</a>
            </p>
          </div>
          <!-- <div class="footer__copyright__payment"><img src="assets/img/payment-item.png" alt=""></div> -->
        </div>
      </div>
      }
    </div>
    }
    @if (CLIENTE === 'musgrave') {
    <div class="container">
      <div class="row">
        <div i18n class="col-lg-6 footer__copyright">
          © 2025 Musgrave España -
          All rights reserved
          <small>
            <a class="footer__autor" href="https://www.asg-si.com" target="_self" title="ASG">
              ASG </a>
          </small>
        </div>
        <div class="col-lg-6">
          <div class="footer__copyright">
            <ul class="footer__politica">
              <li id="">
                <!-- routerLink="privacidad" -->
                <a routerLink="politica-privacidad" i18n>Aviso legal y política de
                  privacidad</a>
              </li>
              <li id="">
                <!-- routerLink="privacidad" -->
                <a i18n href="https://musgrave.es/aviso-legal-politica-privacidad/" target="_blank">Aviso legal y
                  política de
                  privacidad grupo Musgrave</a>
              </li>
              <li id=""><a href="politica-cookies" target="_self" i18n>Política de
                  cookies</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</footer>
<!-- Footer Section End -->